import { Component } from 'preact';
import { ACCENT_GOLD } from '../lib/medievalTheme';
import { getOwnedBadgeState } from './cardOwnedBadge.helpers';

/**
 * "×N owned" tag rendered at the bottom-right of a card thumbnail.
 *
 * Originally inlined as `renderOwnedBadge` in ArenaPackOpening and
 * DraftPicker. Extracted here so the deck editor can reuse the same
 * visual vocabulary with opt-out flags (playsetCompleteVariant=false,
 * hideWhenZero=true). See cardOwnedBadge.helpers for the variant
 * semantics.
 *
 * Mounted via DeckCardTile's `cornerBadge` slot so the badge rides
 * the card's outer wrapper (clear of the inner card mask + transforms).
 */
export default class CardOwnedBadge extends Component {
  render() {
    const { owned, maxCopies, playsetCompleteVariant, hideWhenZero, inline } = this.props;
    const state = getOwnedBadgeState({ owned, maxCopies, playsetCompleteVariant, hideWhenZero });
    if (!state) return null;
    const { playset, label, title } = state;
    // `inline` mode: a static badge the caller positions itself (the deck editor
    // places it in the footer row beside the capacity dots). Default mode is the
    // bottom-right on-card corner overlay used by draft / booster opening.
    return (
      <div
        className={inline
          ? 'rounded font-bold text-[0.625cqw] tabular-nums pointer-events-none'
          : 'absolute z-40 rounded font-bold text-[0.625cqw] tabular-nums pointer-events-none'}
        style={{
          ...(inline ? {} : { bottom: '0.375cqw', right: '0.375cqw' }),
          padding: '0.125cqw 0.375cqw',
          background: 'rgba(0,0,0,0.78)',
          color: playset ? '#7be07b' : ACCENT_GOLD,
          border: `1px solid ${playset ? 'rgba(123,224,123,0.5)' : 'rgba(212,168,67,0.5)'}`,
          textShadow: '0 1px 2px rgba(0,0,0,0.8)',
        }}
        title={title}
      >
        {label}
      </div>
    );
  }
}
